import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { CUSTOMER_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import { EditCustomerRequest, EditCustomerResponse } from './types';
import { useReadCustomerApi } from './use-read-customer-api';

export function useEditCustomerMutationApi(userId: string) {
  return useBaseMutation<EditCustomerRequest, EditCustomerResponse>(
    {
      url: `${CUSTOMER_ROOT_ENDPOINT}/${userId}`,
      method: HttpMethod.patch,
    },
    {
      onSuccess: (data) => {
        baseQueryClient.setQueryData([useReadCustomerApi.name, userId], data);
      },
    }
  );
}
